import React, { Component } from 'react';
import PrismicReact from 'prismic-reactjs';
import { Link, withRouter } from 'react-router-dom';

class Navbar extends Component {
  state = {
    doc: null,
		notFound: null
  }

  componentWillMount() {
    this.fetchNavbar(this.props);
  }

  componentWillReceiveProps(props) {
    this.fetchNavbar(props);
  }

  componentDidUpdate() {
    this.props.prismicCtx.toolbar();
  }

  fetchNavbar(props) {
    if (props.prismicCtx) {

			return props.prismicCtx.api.getSingle('navigation')
				.then((doc) => {
					if (doc) {
          	this.setState({ doc });
        	} else {
          	this.setState({ notFound: !doc });
        	}
			});
    }
  }

	toggleMenu(value) {
		this.setState(prevState => {
			return { menuOpen: value !== undefined ? value : !prevState.menuOpen };
		})
	}

	render() {
	  if (this.state.doc) {
	    return (
	        <div className="navbar-container row">
						<div className="navbar p-0 d-flex justify-content-start col-lg-8 offset-lg-2">
							<div className={`burger ${this.state.menuOpen ? 'open' : ''}`} onClick={() => this.toggleMenu()}>
								<span className="line first" />
								<span className="line second" />
								<span className="line third" />
							</div>
							{this.state.doc.data.links.map(obj => {
									return (
										<Link
											onClick={() => this.toggleMenu(false)}
											className={`cat flex-grow py-3 px-2 ${this.state.menuOpen ? 'show' : ''}`}
											key={PrismicReact.RichText.asText(obj.link_name)}
											to={`/${obj.link_url[0].text}`}
										>
											{obj.link_icon.url
												&& <img alt="icon" className="link-icon p-0 m-0 mx-2" src={obj.link_icon.url} />
											}
											{PrismicReact.RichText.asText(obj.link_name)}
										</Link>
									);
								})
							}
						</div>
					</div>
	    );
	  } else {
			return <div></div>;
		}
	}
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.js